export default {
  see: 'Voir',
  report_info: 'Informations sur le signalement',
  report_title: 'Signalement',
  report: 'Signaler',
  job: {
    reasons: {
      fraudulent_offer: 'Projet frauduleux',
      inappropriate_content: 'Contenu inapproprié',
      false_information: 'Informations fausses ou trompeuses',
      other: 'Autre',
    },
  },
  profile: {
    reasons: {
      fake_identity: 'Fausse identité',
      inappropriate_or_offensive: 'Contenu inapproprié ou offensant',
      spam_or_scam: 'Spam ou arnaque',
      other: 'Autre',
    },
  },
  review: {
    reasons: {
      abusive_review: 'Evaluation abusif ou diffamatoire',
      spam: 'Spam',
      conflict_of_interest: 'Conflit d’intérêts',
      other: 'Autre',
    },
  },
  quote: {
    reasons: {
      fraudulent_quote: 'soumission frauduleux',
      inappropriate_content: 'Contenu inapproprié',
      harassment: 'Arnaque ou harcèlement',
      other: 'Autre',
    },
  },
  quote_request: {
    reasons: {
      fraudulent_request: 'demande frauduleuse',
      inappropriate_content: 'Contenu inapproprié',
      harassment: 'Arnaque ou harcèlement',
      other: 'Autre',
    },
  },
  reportPlaceholder: 'Choisissez une option',
  report_content: 'Faire un signalement',
  report_this_offer: 'Signaler ce projet',
  report_this_quote: 'Signaler cette soumission',
  report_this_user: 'Signaler cet utilisateur',
  report_this_review: 'Signaler cette évaluation',
  report_this_quote_request: 'Signaler cette demande',
  report_this_issue: 'Signaler un problème',
  description:
    'Veuillez sélectionner une raison de signalement. Cela nous aide à maintenir une plateforme sûre et fiable.',
  reason_label: 'Raison du signalement',
  other_reason_label: 'Expliquez votre signalement',
  other_reason_placeholder: 'Détaillez la raison du signalement...',
  link_copied: 'Lien copié avec succès',
  copy_link: 'Copier le lien',
  additional_details_label: 'Détails supplémentaires (optionnel)',
  additional_details_placeholder: 'Ajoutez des explications supplémentaires si nécessaire...',
  report_reasons: {
    fraudulent_request: 'demande frauduleuse',
    inappropriate_content: 'Contenu inapproprié',
    harassment: 'Arnaque ou harcèlement',
    fraudulent_quote: 'soumission frauduleuse',
    abusive_review: 'Evaluation abusif ou diffamatoire',
    spam: 'Spam',
    conflict_of_interest: 'Conflit d’intérêts',
    fake_identity: 'Fausse identité',
    inappropriate_or_offensive: 'Contenu inapproprié ou offensant',
    spam_or_scam: 'Spam ou arnaque',
    fraudulent_offer: 'Projet frauduleux',
    false_information: 'Informations fausses ou trompeuses',
    product_bug: 'Problème technique',
    other: 'Autre',
  },
  has_reported: {
    job: 'a signalé un projet.',
    profile: 'a signalé un utilisateur.',
    review: 'a signalé une évaluation.',
    quote: 'a signalé une soumission.',
    quote_request: 'a signalé une demande de soumission.',
    issue: 'a signalé un problème technique.',
  },
  issue: {
    footer_link: 'Signaler un problème',
    modal_title: 'Signaler un problème',
    modal_description:
      'Décrivez le bug rencontré. La page actuelle est incluse automatiquement pour aider les administrateurs.',
    anonymous_reporter: 'Utilisateur anonyme',
    email_label: 'Votre courriel',
    email_placeholder: 'nom@courriel.com',
    reporter_label: 'Auteur',
    reporter_email_label: 'Courriel de contact',
    title_label: 'Titre du problème',
    title_placeholder: 'Résumé court du problème',
    description_label: 'Description du problème',
    description_placeholder: 'Décrivez ce qui se passe et le résultat attendu.',
    page_label: 'Page où le problème est survenu',
    attachments_label: "Captures d'écran (optionnel)",
    add_screenshot: "Ajouter une capture d'écran",
    attachments_hint: '{{count}}/{{max}} captures sélectionnées',
    remove_attachment: 'Retirer',
    submit_button: 'Envoyer le signalement',
    submit_success: 'Le problème a été signalé avec succès.',
    submit_error: "Impossible d'envoyer le signalement. Veuillez réessayer.",
    validation: {
      max_attachments: "Vous pouvez joindre au plus {{max}} captures d'écran.",
      images_only: "Seules les images sont acceptées pour les captures d'écran.",
      file_size_max: 'Chaque capture doit faire 10 Mo ou moins.',
      invalid_email: 'Veuillez entrer une adresse courriel valide.',
      title_required: 'Le titre du problème est obligatoire.',
      description_required: 'La description du problème est obligatoire.',
      upload_failed: 'Échec du téléversement de la pièce jointe. Veuillez réessayer.',
    },
  },
  already_submitted_warning: 'Vous avez déjà soumis un signalement pour cet élément.',
} as const;
